/**
 * Construit l'URL publique partageable d'un générateur.
 * En dev   : http://localhost:5173/app/g/:orgSlug/:genSlug
 * En prod  : https://site.com/app/g/:orgSlug/:genSlug
 */
export function buildPublicGeneratorUrl(orgSlug: string, genSlug: string): string {
    if (typeof window === 'undefined') {
        return `/app/g/${orgSlug}/${genSlug}`;
    }
    return `${window.location.origin}/app/g/${orgSlug}/${genSlug}`;
}

/**
 * Copie un texte dans le presse-papiers avec fallback execCommand.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch {
        // fall through
    }
    try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
    } catch {
        return false;
    }
}
